import { render, staticRenderFns } from "./Buscar.vue?vue&type=template&id=ab750886&scoped=true&"
import script from "./Buscar.vue?vue&type=script&lang=js&"
export * from "./Buscar.vue?vue&type=script&lang=js&"
import style0 from "./Buscar.vue?vue&type=style&index=0&id=ab750886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab750886",
  null
  
)

export default component.exports